<template>
    <div style="width: 100%">
        <v-toolbar
            flat
            class="d-flex justify-center"
        >
            <v-btn
                outlined
                class="overline"
                color="grey darken-2"
                @click="setToday"
                :disabled="isLoading"
            >
                Hoy
            </v-btn>
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prevMonth"
                :disabled="isLoading"
            >
                <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-toolbar-title
                class="font-weight-light primary--text"
                v-if="$refs.calendar"
            >
                {{
                    $refs.calendar.title.charAt(0).toUpperCase() +
                    $refs.calendar.title.slice(1)
                }}
            </v-toolbar-title>
            <v-btn
                fab
                text
                :small="$vuetify.breakpoint.smAndDown"
                color="grey darken-2"
                @click="nextMonth"
                :disabled="isLoading"
            >
                <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="d-flex">
                <v-btn
                    outlined
                    :small="$vuetify.breakpoint.smAndDown"
                    class="mr-1"
                    color="grey darken-2"
                    v-if="selectedDay"
                    @click="viewMonth()"
                >
                    <v-icon :left="!$vuetify.breakpoint.smAndDown">
                        mdi-arrow-left
                    </v-icon>
                    {{ !$vuetify.breakpoint.smAndDown ? 'Volver' : '' }}
                </v-btn>
                <v-btn
                    outlined
                    class="mr-4"
                    color="success"
                    :small="$vuetify.breakpoint.smAndDown"
                    @click="openCreateHolidays()"
                    :disabled="isLoading"
                >
                    <v-icon :left="!$vuetify.breakpoint.smAndDown">
                        mdi-calendar
                    </v-icon>
                    {{
                        !$vuetify.breakpoint.smAndDown
                            ? 'Establecer Vacaciones'
                            : ''
                    }}
                </v-btn>
            </div>
        </v-toolbar>

        <v-row no-gutters>
            <v-col cols="12" md="6" v-if="hasAdminPermission">
                <v-card style="padding: 20px 43px 19px 43px !important;" class="ma-2" elevation="8">
                    <v-autocomplete
                        class="pa-4"
                        :items="comerciales.filter(
                            ({ nombreCompleto }) => nombreCompleto != 'Por asignar'
                        )"
                        v-model="selectedComercial"
                        item-text="nombreCompleto"
                        :disabled="!comerciales || comerciales.length == 0"
                        return-object
                        prepend-inner-icon="mdi-account"
                        hint="Selecciona un comercial para ver sus vacaciones, por defecto se mostrara el de la cuenta logueada"
                        persistent-hint
                        :menu-props="{ maxHeight: '600' }"
                        label="Comercial"
                        clearable
                    >
                        <template #item="{ item }">
                            <v-row dense>
                                <v-col cols="11">
                                    {{ item.nombreCompleto }}
                                </v-col>
                                <v-col
                                    v-if="item.estado && !$vuetify.breakpoint.smAndDown"
                                    cols="1"
                                >
                                    <v-chip
                                        label
                                        :color="estadoComercial[item.estado]"
                                        medium
                                        class="d-flex justify-center overline"
                                    >
                                        {{ item.estado }}
                                    </v-chip>
                                </v-col>
                                <v-col
                                    v-if="item.estado && $vuetify.breakpoint.smAndDown"
                                    cols="1"
                                >
                                    <v-icon
                                        :color="estadoComercial[item.estado]"
                                        large
                                        class="d-flex justify-center overline"
                                    >
                                        mdi-circle
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </template>
                    </v-autocomplete>
                    <v-progress-linear
                        indeterminate
                        :active="isLoading"
                        style="width: 100%"
                    ></v-progress-linear>
                </v-card>
            </v-col>
            <v-col cols="12" :md="hasAdminPermission ? '6' : '12'">
                <v-card class="pa-4 ma-2" elevation="8">
                    <v-row class="d-flex">
                        <v-col cols="12" md="4" v-for="(value, key) in spentHolidays" :key="key">
                            <v-card class="pa-4" flat>
                                <h3 class="font-weight-light primary--text">
                                    {{ getTitle(key) }}
                                </h3>
                                <v-divider></v-divider>
                                <h2 class="font-weight-light ">
                                    {{ value }}
                                </h2>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-progress-linear
                        indeterminate
                        :active="isLoading"
                        style="width: 100%"
                    ></v-progress-linear>
                </v-card>
            </v-col>
        </v-row>
        <v-card :disabled="isLoading" class="ma-2 pa-2" elevation="8">
            <v-sheet height="75vh">
                <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    locale="es-es"
                    :event-color="getEventColor"
                    :type="type"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @change="setHolidays"
                ></v-calendar>
                <v-menu
                    v-model="selectedOpen"
                    :close-on-content-click="false"
                    :activator="selectedElement"
                    offset-x
                    max-width="500"
                >
                    <v-card max-width="500" flat>
                        <v-toolbar :color="selectedEvent.color" flat>
                            <v-btn icon>
                                <v-icon color="white" size="30">mdi-account</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-toolbar-title
                                class="justify-center font-weight-light white--text"
                                v-html="selectedEvent.name"
                            ></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon v-if="!isFestiveDay && selectedEvent.file" @click="openAttachedFile()">
                                <v-icon color="white" size="30">mdi-paperclip</v-icon>
                            </v-btn>
                            <v-btn v-if="!isFestiveDay && (hasAdminPermission || hasManagerPermission || hasSuperAdminPermission)" icon @click="changeApproval(); selectedEvent.is_accepted=!selectedEvent.is_accepted;">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon 
                                        color="white" 
                                        size="30"
                                        v-bind="attrs"
                                        v-on="on"
                                    >{{ selectedEvent.is_accepted ? 'mdi-check-decagram-outline' : 'mdi-cancel' }}</v-icon>
                                    </template>
                                    <span>{{ selectedEvent.is_accepted ? 'Aprobado' : 'No aprobado' }}</span>
                                </v-tooltip>
                            </v-btn>
                            <v-btn v-if="!isFestiveDay" icon @click="editHolidays()">
                                <v-icon color="white" size="30">mdi-pen</v-icon>
                            </v-btn>
                            <v-btn v-if="!isFestiveDay" icon @click="openDeleteDialog()">
                                <v-icon color="white" size="30">mdi-delete</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <h2
                                class="font-weight-light"
                                v-html="selectedEvent.details"
                            ></h2>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end">
                            <v-btn text color="red" @click="selectedOpen = false">
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-sheet>
        </v-card>
        <HolidaysForm />
        <DeleteDialog />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import HolidaysForm from './HolidaysForm.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';
import { clone } from '@/util/libUtil.js';

export default {
    components: {
        HolidaysForm,
        DeleteDialog,
    },
    data: () => ({
        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
        options: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: 'Europe/Madrid',
        },
        focus: '',
        type: 'month',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        selectedDay: false,
        events: [],
        colors: [
            'blue',
            'indigo',
            'deep-purple',
            'cyan',
            'green',
            'orange',
            'grey darken-1',
        ],
    }),
    mounted() {
        this.$refs.calendar.checkChange();
    },
    created() {
        this.$store.dispatch('teletrabajo/fetchComerciales').then(() => {
            if (!this.selectedComercial) {
                this.selectedComercial = this.comerciales.find(
                    ({ id }) => id == this.cuenta.id
                );
            }
        });
    },
    computed: {
        isFestiveDay() {
            const dateStringRegex = /\b\d{4}-\d{2}-\d{2}\b/;
            return !dateStringRegex.test(this.selectedEvent.details);
        },
        holidaysForm: {
            get() {
                return this.$store.state.holidays.holidaysForm;
            },
            set(val) {
                return this.$store.commit('holidays/holidaysForm', val);
            },
        },
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('holidays', {
            isLoading: (state) => state.isLoading,
            spentHolidays: (state) => state.spentHolidays,
            holidays: (state) => state.holidays,
            selectedComercial: (state) => state.selectedComercial,
            rangoDate: (state) => state.rangoDate,
            festiveDays: (state) => state.workingCalendarObj.workingCalendar,
        }),
        isOpenHolidaysForm: {
            get() {
                return this.$store.state.holidays.isOpenHolidaysForm;
            },
            set(val) {
                return this.$store.commit('holidays/isOpenHolidaysForm', val);
            },
        },
        selectedComercial: {
            get() {
                return this.$store.state.holidays.selectedComercial;
            },
            set(val) {
                this.$store.commit('holidays/selectedComercial', val);
            },
        },
        rangoDate: {
            get() {
                return this.$store.state.holidays.rangoDate;
            },
            set(val) {
                this.$store.commit('holidays/rangoDate', val);
            },
        },
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
            hasManagerPermission: 'hasManagerPermission',
            hasSuperAdminPermission: 'hasSuperAdminPermission',
		}),
    },
    watch: {
        holidays() {
            const events = [];
            this.holidays.forEach((event) => {
                events.push({
                    name: event.commercial.nombreCompleto,
                    commercial: event.commercial,
                    holidays_id: event.id,
                    details:
                        event.begin != event.end
                            ? `Desde ${event.begin} hasta ${event.end}, ${event.type.toLowerCase().replaceAll('_', ' ')}`
                            : `${event.begin}, ${event.type.toLowerCase().replaceAll('_', ' ')}`,
                    start: new Date(event.begin),
                    end: new Date(event.end),
                    is_accepted: event.isAccepted,
                    type: event.type,
                    color: this.getRandomColor(event.begin, event.end),
                    file : event.file,
                    // Fix temporal de timed
                    timed:
                        new Intl.DateTimeFormat('es-ES', this.options)
                            .format(new Date(event.begin))
                            .split(' ')[1] == '1:00:00' ||
                        new Intl.DateTimeFormat('es-ES', this.options)
                            .format(new Date(event.begin))
                            .split(' ')[1] == '2:00:00' ||
                        new Intl.DateTimeFormat('es-ES', this.options)
                            .format(new Date(event.begin))
                            .split(' ')[1] == '0:00:00'
                            ? false
                            : true,
                });
            });

            this.festiveDays.forEach((event) => {
                events.push({
                    name: event.name,
                    details: event.description,
                    start: new Date(event.date),
                    end: new Date(event.date),
                    color: 'red',
                    timed: false,
                });
            });
            this.events = events;
        },
        selectedComercial() {
            this.fetchHolidays(this.rangoDate);
            this.getSpentHolidays();
        },
    },
    methods: {
        getTitle(key){
            switch (key) {
                case 'spent_holidays':
                    return 'Disfrutadas';
                case 'holiday_type':
                    return 'Tipo';
                case 'remain':
                    return 'Restantes';
                default:
                    return key;
            }
        },
        getRandomColor(begin, end) {
            const days = Math.round(
                (new Date(end) - new Date(begin)) / 86400000
            );

            if (days < 2) {
                return 'green lighten-1';
            } else if (days < 6) {
                return 'green darken-1';
            } else if (days < 7) {
                return 'yellow lighten-1';
            } else if (days < 13) {
                return 'yellow darken-1';
            } else if (days < 20) {
                return 'purple';
            }
            return 'indigo';
        },
        openCreateHolidays() {
            this.$store.commit('holidays/holidaysFormType', 'CREATE');
            this.$store.commit('holidays/isOpenHolidaysForm', true);
        },
        ...mapActions('holidays', ['fetchHolidays', 'getSpentHolidays', 'changeHolidaysApproval']),
        viewDay({ date }) {
            this.focus = date;
            this.type = 'day';
            this.selectedDay = true;
        },
        viewMonth() {
            this.type = 'month';
            this.selectedDay = false;
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = '';
        },
        prevMonth() {
            this.$refs.calendar.prev();
        },
        nextMonth() {
            this.$refs.calendar.next();
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                requestAnimationFrame(() =>
                    requestAnimationFrame(() => (this.selectedOpen = true))
                );
            };

            if (this.selectedOpen) {
                this.selectedOpen = false;
                requestAnimationFrame(() =>
                    requestAnimationFrame(() => open())
                );
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        openDeleteDialog() {
            console.log(this.selectedEvent);
            let deleteObj = {
                toDeleteId: this.selectedEvent.holidays_id,
                toDeleteType: 'HOLIDAYS',
                isOpenDeleteDialog: true,
                additionalParams: this.rangoDate,
            };
            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        changeApproval() {
            this.changeHolidaysApproval(this.selectedEvent.holidays_id);
        },
        openAttachedFile(){
            window.open(this.selectedEvent.file, '_blank');
        },
        editHolidays() {
            this.holidaysForm.commercial = this.selectedEvent.commercial;
            this.holidaysForm.begin = this.selectedEvent.start;
            this.holidaysForm.end = this.selectedEvent.end;
            this.holidaysForm.id = this.selectedEvent.holidays_id;

            this.$store.commit('holidays/holidaysFormType', 'EDIT');
            this.$store.commit('holidays/isOpenHolidaysForm', true);
        },
        setHolidays({ start, end }) {
            if (this.type != 'day') {

                if (
                    this.rangoDate &&
                    this.rangoDate.start !== start &&
                    this.rangoDate.end !== end
                ) {
                    this.rangoDate = { start, end };
                    this.fetchHolidays(this.rangoDate);
                } else {
                    this.rangoDate = { start, end };
                }
            }
        },
        compareDate(date1, date2) {
            if (
                date1.getDate() == date2.getDate() &&
                date1.getMonth() == date2.getMonth() &&
                date1.getFullYear() == date2.getFullYear()
            )
                return true;
            else return false;
        },
    },
};
</script>